import { __rest, __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var FeedbackOutline = function (_a) {
  var _b = _a.fill,
    fill = _b === void 0 ? 'currentColor' : _b,
    props = __rest(_a, ["fill"]);
  return React__default.createElement("svg", __assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M9.34066 0.805664L8.60173 4.05924L5.58903 6.61458C5.21583 6.93114 4.99984 7.39698 4.99984 7.88574V15.8333C4.99984 16.7442 5.75562 17.5 6.6665 17.5H13.8621C14.4902 17.5 15.0675 17.1432 15.3498 16.5837L18.1965 10.9391C18.2885 10.7602 18.3332 10.5627 18.3332 10.3695V8.33333C18.3332 7.42245 17.5774 6.66667 16.6665 6.66667H12.8628C13.0978 5.93587 13.3332 4.98878 13.3332 4.05273C13.3332 2.60632 12.4281 1.65822 11.6209 1.25651C10.8138 0.854805 10.034 0.833333 10.034 0.833333L9.34066 0.805664ZM10.6232 2.67904C10.7405 2.71435 10.7548 2.68733 10.8787 2.74902C11.3216 2.9694 11.6665 3.21415 11.6665 4.05273C11.6665 5.20982 10.8983 7.17611 10.8983 7.17611L10.41 8.33333H16.6665V10.2702L13.8621 15.8333H6.6665V7.88574L10.104 4.96908L10.6232 2.67904ZM1.6665 6.66667V17.5H3.33317V6.66667H1.6665Z",
    fill: fill
  }));
};
export { FeedbackOutline as default };
//# sourceMappingURL=FeedbackOutline.js.map
